import { Group, Tooltip, UnstyledButton, createStyles } from '@mantine/core';
import type { IconNames } from '@repo/foundations';
import { Icon, IconButton, Text } from '@repo/foundations';
import { memo } from 'react';

const useStyles = createStyles((theme) => ({
	activeButton: {
		padding: `${theme.spacing['3xs']} ${theme.spacing.xs} ${theme.spacing['3xs']} ${theme.spacing['3xs']}`,
		backgroundColor: theme.other.getColor('fill/transparent/selected'),
		borderRadius: theme.radius.sm,
	},
}));

interface AiInputToggleButtonProps {
	label: string;
	icon: IconNames;
	active: boolean;
	onToggle: (value: boolean) => void;
}

export const AiInputToggleButton = memo(
	({ label, icon, active, onToggle }: AiInputToggleButtonProps) => {
		const { classes } = useStyles();

		return (
			<Tooltip
				label={`Turn ${active ? 'off' : 'on'} ${label.toLowerCase()}`}
				position="top"
				offset={8}
			>
				{active ? (
					<UnstyledButton
						data-active={active ? 'true' : undefined}
						className={classes.activeButton}
						onClick={() => onToggle(!active)}
						data-testid={`ai-input-toggle-${label.toLowerCase().replace(/\s+/g, '-')}`}
					>
						<Group spacing="3xs">
							<Icon name={icon} size="md" />
							{active && (
								<Text size="xs" fw={500}>
									{label}
								</Text>
							)}
						</Group>
					</UnstyledButton>
				) : (
					<IconButton
						iconName={icon}
						variant="tertiary"
						onClick={() => onToggle(true)}
					/>
				)}
			</Tooltip>
		);
	}
);
